import { ISDKResponseInterceptor } from "@sol/sdk";
import { notification } from "@sol/uikit/feedback/Notification/Notification";

import i18n from "./i18n";

/**
 * Interceptor to detect maintenance mode (503) and display a user-friendly notification
 * instead of showing errors or forcing a page reload
 **/
export const maintenanceInterceptor: ISDKResponseInterceptor = {
    kind: "response",
    onFullfilled: response => response,
    onRejected: error => {
        // Si l'API retourne 503 (Service Unavailable), c'est le mode maintenance
        if (error?.response?.status === 503) {
            notification.warning({
                message: i18n.t("errors.maintenance.title"),
                description: i18n.t("errors.maintenance.description"),
                duration: 0, // Ne pas fermer automatiquement
                placement: "top",
            });
        }

        return Promise.reject(error);
    },
};
